// extracted by mini-css-extract-plugin
module.exports = {"bookingColor1":"#0085ca","bookingColor2":"#f93822","bookingColor3":"#ffa400","bookingColor4":"#00ab84","bookingColor5":"#bb29bb"};